const FINAL_AFFAIR_STAGES = new Set(['won', 'lost', 'abandoned']);
const CLOSED_PROJECT_STATUSES = new Set(['termine', 'archive', 'annule', 'completed', 'archived', 'cancelled']);
const PENDING_QUOTE_STATUSES = new Set(['internal_review', 'sent']);

export const asArray = (value) => (Array.isArray(value) ? value : []);

const read = (row, ...keys) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null && row?.[key] !== '') return row[key];
  }
  return null;
};
const numberOf = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};
const normalizedStatus = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const getLatestActivityDate = (activities) => {
  let latest = null;
  asArray(activities).forEach((activity) => {
    const value = read(activity, 'activityDate', 'activity_date', 'occurredAt', 'occurred_at');
    const timestamp = value ? Date.parse(value) : Number.NaN;
    if (Number.isFinite(timestamp) && (!latest || timestamp > latest.timestamp)) latest = { timestamp, value };
  });
  return latest?.value || null;
};

const getContractedAmount = (affairs, projects) => asArray(affairs)
  .filter((affair) => normalizedStatus(affair.stage) === 'won')
  .reduce((total, affair) => {
    const directAmount = read(affair, 'contractedAmount', 'contracted_amount', 'acceptedAmount', 'accepted_amount');
    if (directAmount !== null) return total + numberOf(directAmount);
    const affairId = read(affair, 'id');
    const projectAmount = asArray(projects)
      .filter((project) => String(read(project, 'affairId', 'affair_id')) === String(affairId))
      .reduce((sum, project) => sum + numberOf(read(project, 'soldAmount', 'sold_amount')), 0);
    return total + projectAmount;
  }, 0);

export const getPartnerMetrics = (overview = {}) => {
  const affairs = asArray(overview?.affairs);
  const projects = asArray(overview?.projects);
  const quotes = asArray(overview?.quotes);
  const activities = asArray(overview?.activities);
  const openAffairs = affairs.filter((affair) => !FINAL_AFFAIR_STAGES.has(normalizedStatus(affair.stage)));

  return {
    affairCount: affairs.length,
    openAffairCount: openAffairs.length,
    pendingQuoteCount: quotes.filter((quote) => PENDING_QUOTE_STATUSES.has(normalizedStatus(quote.status))).length,
    activeProjectCount: projects.filter((project) => !CLOSED_PROJECT_STATUSES.has(normalizedStatus(project.status))).length,
    potentialAmount: openAffairs.reduce((sum, affair) => sum + numberOf(read(affair, 'estimatedAmount', 'estimated_amount')), 0),
    weightedPotentialAmount: openAffairs.reduce((sum, affair) => {
      const amount = numberOf(read(affair, 'estimatedAmount', 'estimated_amount'));
      const probability = Math.min(100, Math.max(0, numberOf(read(affair, 'probabilityPercent', 'probability_percent'))));
      return sum + (amount * probability / 100);
    }, 0),
    contractedAmount: getContractedAmount(affairs, projects),
    lastActivityAt: getLatestActivityDate(activities),
  };
};
